<template>
  <b-select
    :value="value"
    :style="{'font-family': value}"
    @input="$emit('input', $event)"
  >
    <option
      v-for="font in fonts"
      :key="font.displayName"
      :value="font.fontFamily"
      :style="{'font-family': font.fontFamily}"
    >
      {{ font.displayName }}
    </option>
  </b-select>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  value: {
    type: String,
    default: '',
  },
}

@Component
export default class FontPicker extends Vue.extend({ props }) {
  fonts = [
    { fontFamily: '"Times New Roman", Times, serif', displayName: 'Times New Roman' },
    { fontFamily: 'Georgia, serif', displayName: 'Georgia' },
    { fontFamily: '"Palatino Linotype", "Book Antiqua", Palatino, serif', displayName: 'Palatino Linotype' },
    { fontFamily: 'Arial, Helvetica, sans-serif', displayName: 'Arial' },
    { fontFamily: '"Arial Black", Gadget, sans-serif', displayName: 'Arial Black' },
    { fontFamily: '"Comic Sans MS", cursive, sans-serif', displayName: 'Comic Sans MS' },
    { fontFamily: 'Impact, Charcoal, sans-serif', displayName: 'Impact' },
    { fontFamily: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', displayName: 'Lucida Sans Unicode' },
    { fontFamily: 'Tahoma, Geneva, sans-serif', displayName: 'Tahoma' },
    { fontFamily: '"Trebuchet MS", Helvetica, sans-serif', displayName: 'Trebuchet MS' },
    { fontFamily: 'Verdana, Geneva, sans-serif', displayName: 'Verdana' },
    { fontFamily: '"Courier New", Courier, monospace', displayName: 'Courier New' },
    { fontFamily: '"Lucida Console", Monaco, monospace', displayName: 'Lucida Console' },
    { fontFamily: '"Open Sans", sans-serif', displayName: 'Open Sans' },
    { fontFamily: '"Source Sans Pro", sans-serif', displayName: 'Source Sans Pro' },
  ]
}

</script>
